export const studentResultData = [
  {
    Key: "1",
    Img: "user-01.jpg",
    Score: "75",
    StudentName: "Thompson Hicks",
    Attempts: "04",
    FinishTime: "22 Aug 2025, 09:00 AM",
  },
  {
    Key: "2",
    Img: "user-06.jpg",
    Score: "50",
    StudentName: "Jennifer Tovar",
    Attempts: "03",
    FinishTime: "10 Aug 2025, 09:15 AM",
  },
  {
    Key: "3",
    Img: "user-09.jpg",
    Score: "60",
    StudentName: "James Schulte",
    Attempts: "02",
    FinishTime: "26 Jul 2025, 02:20 PM",
  },
  {
    Key: "4",
    Img: "user-20.jpg",
    Score: "55",
    StudentName: "Kristy Cardona",
    Attempts: "02",
    FinishTime: "12 Jul 2025, 11:40 AM",
  },
  {
    Key: "5",
    Img: "user-27.jpg",
    Score: "45",
    StudentName: "William Aragon",
    Attempts: "04",
    FinishTime: "02 Jul 2025, 04:30 PM",
  },
  {
    Key: "6",
    Img: "user-30.jpg",
    Score: "60",
    StudentName: "Shirley Lis",
    Attempts: "01",
    FinishTime: "25 Jun 2025, 08:10 AM",
  },
  {
    Key: "7",
    Img: "user-17.jpg",
    Score: "45",
    StudentName: "John Brewer",
    Attempts: "02",
    FinishTime: "17 Jun 2025, 06:30 PM",
  },
  {
    Key: "8",
    Img: "user-37.jpg",
    Score: "70",
    StudentName: "Doris Hughes",
    Attempts: "04",
    FinishTime: "20 May 2025, 06:30 PM",
  },
  {
    Key: "9",
    Img: "user-04.jpg",
    Score: "65",
    StudentName: "Sarah Martinez",
    Attempts: "03",
    FinishTime: "04 Jun 2025, 05:00 PM",
  },
  {
    Key: "10",
    Img: "user-18.jpg",
    Score: "40",
    StudentName: "Sarah Martinez",
    Attempts: "03",
    FinishTime: "15 May 2025, 01:40 PM",
  },
];
